import { AxiosResponse } from 'axios';
import client from 'api/client';
import { CompanyData } from 'api/models/response/CompaniesList';

export const getCompanies = (): Promise<AxiosResponse<CompanyData>> => {
    return client.get<CompanyData>('/list-companies');
};
